export default {
  sm: `
  DATA CENTER GAK
  that protects
  today
  `,
  md: `
  DATA CENTER GAK
  that protects today
  `,
};
